import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Shield, Lock, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { API } from './Common';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/admin-login`, {
        username,
        password
      });

      if (response.data.success) {
        localStorage.setItem('admin_token', response.data.token);
        localStorage.setItem('admin_logged_in', 'true');
        toast.success('Login successful!');
        navigate('/admin');
      }
    } catch (error) {
      toast.error('Invalid credentials');
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="scan-line" />
      
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img 
            src="/logo.png" 
            alt="Smart Info" 
            className="h-32 mx-auto mb-6"
          />
          <Shield className="w-16 h-16 mx-auto mb-4 text-primary" />
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-2">
            Admin Login
          </h1>
          <p className="text-muted-foreground">Smart Info Security Assessment</p>
        </div>

        <form onSubmit={handleLogin} className="glass-panel rounded-sm p-8 border-2 border-primary/50">
          <div className="space-y-6">
            <div>
              <label className="block text-sm mb-2 flex items-center gap-2">
                <User className="w-4 h-4" />
                Username
              </label>
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                data-testid="username-input"
                placeholder="admin"
                required
                className="bg-transparent border-b border-white/20 focus:border-primary outline-none rounded-none px-0 py-4 text-lg"
              />
            </div>

            <div>
              <label className="block text-sm mb-2 flex items-center gap-2">
                <Lock className="w-4 h-4" />
                Password
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="password-input"
                placeholder="••••••••"
                required
                className="bg-transparent border-b border-white/20 focus:border-primary outline-none rounded-none px-0 py-4 text-lg"
              />
            </div>

            <Button
              type="submit"
              disabled={loading || !username || !password}
              data-testid="login-button"
              className="w-full h-14 rounded-sm border border-primary bg-primary/10 text-primary hover:bg-primary hover:text-black transition-all duration-300 uppercase tracking-widest font-mono disabled:opacity-50"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </div>
        </form>

        <div className="text-center mt-6">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            data-testid="back-home-button"
            className="text-muted-foreground hover:text-primary"
          >
            ← Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
